import { Injectable } from '@angular/core';

export type UserRole = 'super_admin' | 'admin' | 'manager' | 'viewer';

export interface CurrentUser {
  name: string;
  initials: string;
  email: string;
  role: UserRole;
  roleLabel: string;
}

const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: 'Super Administrator',
  admin:       'Administrator',
  manager:     'Manager',
  viewer:      'Viewer'
};

function toInitials(name: string): string {
  return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
}

@Injectable({ providedIn: 'root' })
export class AuthService {

  private user: CurrentUser = {
    name:      'Admin User',
    initials:  'AU',
    email:     'admin@signatech.com',
    role:      'admin',
    roleLabel: ROLE_LABELS['admin']
  };

  getUser(): CurrentUser {
    return this.user;
  }

  getRole(): UserRole {
    return this.user.role;
  }

  setUser(name: string, email: string, role: UserRole): void {
    this.user = { name, email, role, initials: toInitials(name), roleLabel: ROLE_LABELS[role] };
  }

  hasRole(...roles: UserRole[]): boolean {
    return roles.includes(this.user.role);
  }
}
